import {injectable} from 'inversify'
import {FetchOptionsFactoryProxyInterface} from '@/src/core/domain/page/functions/fetch/types'

@injectable()
export class LoginFetchOptionsFactoryProxy implements FetchOptionsFactoryProxyInterface {
  create() {
    return async () => ({
      // TODO убрать
    })
  }
}
